import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Events } from '../provider/events.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    appFlow: boolean;
    constructor(
        private events: Events,
        private toastCtrl: ToastController,
        private translate: TranslateService,
        private router: Router,
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isAuthenticated = window.localStorage.getItem('auth-token') !== 'null' &&
                                window.localStorage.getItem('auth-token') != null &&
                                window.localStorage.getItem('auth-verify') != 'false';

        if (isAuthenticated) {
            // Check condition to determine which page should be the default
            const someCondition = this.checkSomeCondition(); // Your condition logic here
            console.log(someCondition,'someconditions')
            if (state.url === '/tabs') { // If navigating to the main tabs
                const redirectPath = someCondition ? '/tabs/order' : '/tabs/calendar';
                this.router.navigate([redirectPath]);
                // return false; // Prevents original navigation
            }

            return true;
        } else {
            this.events.publish('user:login', { user: null, time: new Date() });
            this.toastCtrl.create({
                message: this.translate.instant('login_to_access_app'),
                duration: 2300,
                position: 'top',
                color: 'light'
            }).then(toastElem => toastElem.present());

            return false;
        }
    }

    private checkSomeCondition(): boolean {
        // const storeData = window.localStorage.getItem('setFlow') 
		// this.appFlow = storeData == 'true' ? true : false;
        // Replace this with your actual condition logic
        return false
    }
}